import { useCallback } from 'react';
import { InputStatuses, Typography, TypographyColors, TypographyVariants } from '@carboledger/ui';
import { DateInput } from '@/components/common';
import { useTranslations } from '@/hooks';
import styles from './SummaryDateRange.module.scss';

/**
 * Props:
 *   from      `yyyy-MM-dd`, the first day the reports cover
 *   to        `yyyy-MM-dd`, the last day they cover — inclusive, as on any calendar
 *   onChange  ({ from, to }) => void
 *   invalid   To falls before From, so the reports are not run
 */
export const SummaryDateRange = ({ from, to, onChange, invalid = false }) => {
  const t = useTranslations();
  const status = invalid ? InputStatuses.error : undefined;

  const handleFromChange = useCallback(
    (event) => onChange({ from: event.target.value, to }),
    [onChange, to],
  );
  const handleToChange = useCallback(
    (event) => onChange({ from, to: event.target.value }),
    [onChange, from],
  );

  return (
    <div className={styles.range}>
      <div className={styles.inputs}>
        <DateInput
          value={from}
          onChange={handleFromChange}
          ariaLabel={t('COMMON_FROM')}
          status={status}
          filled
        />
        <Typography variant={TypographyVariants.bodyXs} color={TypographyColors.primary}>
          -
        </Typography>
        <DateInput
          value={to}
          onChange={handleToChange}
          ariaLabel={t('COMMON_TO')}
          status={status}
          filled
        />
      </div>
      {invalid ? (
        <Typography variant={TypographyVariants.bodyXs} color={TypographyColors.error}>
          {t('INVENTORY_RANGE_TO_BEFORE_FROM')}
        </Typography>
      ) : null}
    </div>
  );
};
